import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FORM_MODE } from 'shared/enums';
import { getMailingsAction } from 'modules/mailingRuleByServiceCategoryList';
import { REQUEST_LIFE_CICLE } from 'interfaces/requests';
import { resetStrategyRegisterAction } from 'modules/strategy';
import { clearDrillDownInterval } from 'modules/simulationList';

interface IStrategyNavigationModeState {
  mode: FORM_MODE;
  loading: REQUEST_LIFE_CICLE;
}

const initialState = {
  mode: FORM_MODE.list,
  loading: REQUEST_LIFE_CICLE.IDLE,
} as IStrategyNavigationModeState;

export const setSelectedStrategyModeAction = createAsyncThunk<
  FORM_MODE,
  FORM_MODE
>(
  'strategyModeNavigation/setNavigation',
  async (payload: FORM_MODE, { dispatch }) => {
    dispatch(resetStrategyRegisterAction());
    if (payload !== FORM_MODE.list && payload !== FORM_MODE.listDetail) {
      dispatch(getMailingsAction());
      dispatch(clearDrillDownInterval());
    }
    return payload;
  },
);

const strategyNavigationModeSlice = createSlice({
  name: 'strategyModeNavigation',
  initialState,
  reducers: {
    resetStrategyModeAction(state) {
      state = initialState;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setSelectedStrategyModeAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
      return state;
    });
    builder.addCase(
      setSelectedStrategyModeAction.fulfilled,
      (state, action) => {
        state.mode = action.payload;
        state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
        return state;
      },
    );
  },
});
const { reducer, actions } = strategyNavigationModeSlice;
export const { resetStrategyModeAction } = actions;
export default reducer;
